import React from 'react';
import PropTypes from 'prop-types';
import IconConfig from 'svgIcons/MotionPortalIcons/IconConfig';
// import { useHistory } from 'react-router';
// import { routes } from 'routes';

const UserLimitsButton = (props) => {

    // const history = useHistory();

    const { kpi } = props;
    const { isPlottableToTrendChart } = kpi;

    const openUserLimitsConfig = (e) => {
        e.stopPropagation();
        // history.push(`${routes.LimitsConfiguration}${history.location.search}`);
        props.setShowLimitSetting(true);
        props.setClickedConfigKpi(kpi?.timeseriesKey);
    };

    return <>
        {
            isPlottableToTrendChart ?
                <button type='button' onClick={(e) => openUserLimitsConfig(e)}>
                    <IconConfig />
                </button> : null
        }
    </>;
};

UserLimitsButton.propTypes = {
    kpi: PropTypes.object,
    setShowLimitSetting: PropTypes.func,
    setClickedConfigKpi: PropTypes.func
};

export default UserLimitsButton;
